<template>
  <div class="p-the-page-error c-common-footer-fixed">
    <div class="c-common-footer-fixed__inner">
      <TheSimpleHeader />

      <div class="p-the-page-error__inner c-common-inner">
        <CommonHeading class="p-the-page-error__heading">
          {{ errorTitleText }}
        </CommonHeading>

        <p class="p-the-page-error__sub_title__text" v-if="errorSubTitleText">
          {{ errorSubTitleText }}
        </p>

        <div class="p-the-page-error__message">
          <p
            class="p-the-page-error__message__text"
            v-for="(messageText, key) in errorMessageTexts"
            :key="key"
          >
            {{ messageText }}
          </p>
        </div>

        <div class="p-form-button-group">
          <div class="p-form-button-group__vertical">
            <ButtonMain kind="cancel" @click-button="buttonAction">
              {{ errorButtonText }}
            </ButtonMain>
          </div>
        </div>
      </div>
    </div>

    <TheFooter />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

import TheSimpleHeader from "@/common/components/organisms/TheSimpleHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";
import CommonHeading from "@/common/components/atoms/CommonHeading.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";

import commons from "@/common/store/modules/commons";
import LocalStorage from "@/general/utils/storage";

@Options({
  props: {
	errorData: { type: Object, required: true },
	errorType: { type: String, default: "error" }
  },
  components: {
    TheSimpleHeader,
    TheFooter,
    CommonHeading,
    ButtonMain
  }
})
export default class ThePageError extends Vue {
  errorData!: any;

  // errorType - error, service or maintenance
  errorType!: any;

  get errorTitleText() {
    let title = this.errorData.title;

    if (
      this.errorType === "maintenance" &&
      LocalStorage.getItem("MAINTENANCE_TITLE")
    ) {
      title = LocalStorage.getItem("MAINTENANCE_TITLE") as string;
    } else if (
      this.errorType === "service" &&
      LocalStorage.getItem("SERVICE_TITLE")
    ) {
      title = LocalStorage.getItem("SERVICE_TITLE") as string;
    }

    return title;
  }

  get errorSubTitleText() {
    return this.errorData.subTitle;
  }

  get errorMessageTexts() {
    let message = this.errorData.message;

    if (
      this.errorType === "maintenance" &&
      LocalStorage.getItem("MAINTENANCE_MESSAGE")
    ) {
      message = LocalStorage.getItem("MAINTENANCE_MESSAGE") as string;
    } else if (
      this.errorType === "service" &&
      LocalStorage.getItem("SERVICE_MESSAGE")
    ) {
      message = LocalStorage.getItem("SERVICE_MESSAGE") as string;
    }

    return message.split("\n");
  }

  get errorButtonText() {
    return this.errorData.button.label;
  }

  buttonAction() {
    if (this.errorData.button.action === "closeWindow") {
      window.close();
    } else if (this.errorData.button.action === "toLoginPage") {
      window.location.href = commons.LOGIN_URL;
    }
  }
}
</script>

<style lang="scss" scoped>
.p-the-page-error {
  background-color: $common-white;
  &__inner {
    max-width: rem(664);
    padding-bottom: rem(80);
    @include sp {
      padding-bottom: rem(40);
    }
  }
  &__heading {
    margin-top: rem(48);
    @include sp {
      margin-top: rem(24);
    }
  }
  &__sub_title__text {
    font-size: rem(14);
    line-height: (24/14);
    margin-top: rem(24);
  }
  &__message {
    margin-top: rem(20);
    @include sp {
      margin-top: rem(16);
    }
    &__text {
      font-size: rem(14);
      line-height: (24/14);
      min-height: em(1);
    }
  }
}
</style>
